import { render, staticRenderFns } from "./AiRecommendationCard.vue?vue&type=template&id=ef6e53d0&scoped=true"
import script from "./AiRecommendationCard.vue?vue&type=script&lang=js"
export * from "./AiRecommendationCard.vue?vue&type=script&lang=js"
import style0 from "./AiRecommendationCard.vue?vue&type=style&index=0&id=ef6e53d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6e53d0",
  null
  
)

export default component.exports